import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Update,
    GetById,
    GetAllCandidates,
} from "adminApi/CandidateInterviewApi/CandidateInterview";
import { validateForm } from "utils/validation";
import { CandidateInterviewRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditCandidateInterviewForm from "./components/EditCandidateInterviewForm";
import fields from "../json/CandidateInterview.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditCandidateInterview = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // HandleInputChange
    const {
        values,
        errors,
        handleChange,
        setErrors,
        setValues
    } = useFormChange(
        initialValues,
        CandidateInterviewRules
    );

    // Fetch existing data by ID
    const {
        loading: loadingFetch
    } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Fetch shortlisted candidates for dropdown
    const { data: CandidateOptions = [] } = useFetchAllData(GetAllCandidates);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, CandidateInterviewRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Interview Updated Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditCandidateInterviewForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Candidate Interview"
                CandidateOptions={CandidateOptions}
            />
        </>
    );
};

export default EditCandidateInterview;
